import 'mapbox-gl/dist/mapbox-gl.css'; // 引入CSS样式
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
